import React from 'react';
import { Tab, TabWrapper } from './styled';
import { AGENTS, RUN_STATUS_LOG } from './constants';
import { useDispatch } from 'react-redux';
import { setAgentsEntity } from 'store/Agents/actions';
import { RUNNERS_ENTITY, AGENTS_EXECUTION_ENTITY } from 'store/Agents/reducer';
import { openModal } from 'store/modals/actions';
import { MODAL_UPGRADE_LICENSE_CLOUD_AGENTS } from 'store/modals/modals';

const TAB_ENTITY_MAP = {
  [AGENTS]: RUNNERS_ENTITY,
  [RUN_STATUS_LOG]: AGENTS_EXECUTION_ENTITY
};

const Tabs = ({ selectedTab, setSelectedTab }) => {
  const dispatch = useDispatch();

  const onClick = (tab) => {
    dispatch(setAgentsEntity(TAB_ENTITY_MAP[tab]));
    setSelectedTab(tab);
  };

  const onClickCloudAgents = () => dispatch(openModal(MODAL_UPGRADE_LICENSE_CLOUD_AGENTS));

  return (
    <TabWrapper>
      <Tab isActive={ selectedTab === AGENTS } onClick={ () => onClick(AGENTS) }>Runners</Tab>
      <Tab isActive={ false } onClick={ onClickCloudAgents } >Security Scanners</Tab>
      <Tab isActive={ selectedTab === RUN_STATUS_LOG } onClick={ () => onClick(RUN_STATUS_LOG) }>Run Status Log</Tab>
    </TabWrapper>
  );
};

export default Tabs;
